import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-sticky-footer',
  templateUrl: './sticky-footer.component.html',
  standalone: true,
})
export class StickyFooterComponent implements AfterViewInit {
  @ViewChild('divAddFooterHeight') divAddFooterHeight!: ElementRef;
  @ViewChild('stickyFooter') stickyFooter!: ElementRef;
  @ViewChild('stickyFooterContainer') stickyFooterContainer!: ElementRef;
  _show = false;

  constructor(private renderer: Renderer2) {}

  @Input() set show(_show: boolean) {
    this._show = _show;

    if (!this.stickyFooterContainer) {
      return;
    }

    const styleValue = this._show ? 'block' : 'none';
    this.renderer.setStyle(this.stickyFooterContainer.nativeElement, 'display', styleValue);
  }

  ngAfterViewInit(): void {
    const { height, paddingTop, paddingBottom } = window.getComputedStyle(this.stickyFooter.nativeElement);
    const margin = 80;

    const heightToAdd =
      parseInt(height.replace('px', '')) +
      parseInt(paddingTop.replace('px', '')) +
      parseInt(paddingBottom.replace('px', '')) +
      margin;

    this.renderer.setStyle(this.divAddFooterHeight.nativeElement, 'height', `${heightToAdd}px`);
  }
}
